import { api } from '@/services/Api';

export default {
    install: () => {
        setInterval(async () => {
            await api.get('api/version');
        }, 300000);
    }
};